var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ext)?_c('div',{staticStyle:{"position":"absolute","right":"0px","bottom":"0px","line-height":"0","padding":"10px 10px","color":"white"},style:({'background-color': _vm.backgroundColor})},[_vm._v(_vm._s(_vm.ext))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }